module.exports = __webpack_public_path__ + "static/media/scale-icon.daa35493.svg";